import api from '.';

export interface BulkCreateProjectPositionWorkflowStep {
  workflowStepId: number;
  projectPositionIds: number[];
}

export async function bulkCreateProjectPositionWorkflowSteps(
  bulkCreateProjectPositionWorkflowStep: BulkCreateProjectPositionWorkflowStep
) {
  const { data } = await api.post(
    '/project-position-workflow-steps/bulk-create',
    bulkCreateProjectPositionWorkflowStep
  );

  return data;
}

export function deleteProjectPositionWorkflowStep(id: number) {
  api.delete(`/project-position-workflow-steps/${id}`);
}
